export default "__VITE_ASSET__cg6DtZ3u__"